
import React from "react";
import BookingForm from "../components/BookingForm";

const Karlandi = () => {
    return (
        <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-16 pb-20 px-6">
            <div className="max-w-6xl mx-auto">
                {/* Title */}
                <h1 className="text-4xl md:text-5xl font-bold text-primarymb-10 text-center">
                    Vaalpark – Karlandi SC – Self-Catering
                </h1>

                {/* Gallery + Description */}
                <div className="grid md:grid-cols-2 gap-10 mb-16 items-start">
                    {/* Gallery */}
                    <div className="grid grid-rows-[auto_1fr] gap-4">
                          <img
                            src="placeholder image.png"
                            alt="Karlandi Main Image"
                            className="w-full h-auto aspect-[16/9] object-cover rounded-lg border-4 border-[#FEB339]"
                        />
                    <div className="grid grid-cols-2 gap-4">
                        {[...Array(5)].map((_, i) => (
                            <img
                                key={i}
                                src="placeholder image.png"
                                alt={`Karlandi Gallery Image ${i + 1}`}
                                className="rounded-lg aspect-[4/3] object-cover border-4 border-[#FEB339]"
                            />
                        ))}
                    </div>
                    </div>

                    {/* Description */}
                    <div>
                        <p className="text-lg leading-relaxed mb-4">
                            Karlandi SC is a practical and private accommodation choice in the quiet suburb of Vaalpark. While detailed information is limited, it is known for its contractor-friendly setup and self-catering convenience.
                        </p>
                        <ul className="list-disc ml-5 text-sm space-y-2">
                            <li>Quiet and accessible location</li>
                            <li>Contractor-friendly setup</li>
                            <li>Private accommodation with secure access</li>
                            <li>Self-catering convenience</li>
                        </ul>
                    </div>
                </div>


                {/* Booking Form */}

                <BookingForm hotelName="Karlandi"/>

            </div>
        </div>
    );
};

export default Karlandi;
